import cookie from 'js-cookie'
import GLOBAL_VARIABLE from "../../constants/global-variable.enum"

const NEXON_DOMAIN = 'nexon.com'
const INSIGN_DOMAIN = 'signin.nexon.com'

class InfaceClient {
  constructor({ domain, referrerDomain }) {
    this._domain = domain || location.hostname
    this._referrerDomain = referrerDomain
  }

  get domain() {
    return this._domain
  }

  set domain(value) {
    this._domain = value
  }

  get referrerDomain() {
    return this._referrerDomain
  }

  set referrerDomain(value) {
    this._referrerDomain = value
  }

  get useCors() {
    return this.checkCors(this.domain)
  }

  get useCorsReferrer() {
    return this.checkCors(this.referrerDomain)
  }

  checkCors(domain) {
    return domain && !(domain?.includes(NEXON_DOMAIN)) // nexon.com 체크
  }

  getCookie(key) {
    return cookie?.get(key)
  }

  setCookie(key, value, options) {
    const attrs = this.useCors ? { ...options } : { domain: NEXON_DOMAIN, ...options } // 쿠키 정책 확인
    cookie?.set(key, value, attrs)
  }

  removeCookie(key, options) {
    const attrs = this.useCors ? { ...options } : { domain: NEXON_DOMAIN, ...options }
    cookie?.remove(key, attrs)
  }

  setIfCookie(key, value) {
    const HOSTNAME = location.hostname
    const isSigninPage = HOSTNAME.includes(INSIGN_DOMAIN)

    if (value) {
      this.setCookie(key, value)
    } else if (!isSigninPage) {
      this.removeCookie(key)
    }
  }

  appendClearParamIfUseCors(params, key, value) {
    if (this.useCors && !value) {
      params.append(`clear_if${key}`, true)
    }
  }

  getQuery({ platform, gid, locale, redirect_uri, options } = {}) {
    platform = platform || this.getCookie(GLOBAL_VARIABLE.PLATFORM_KEY)
    gid = gid || this.getCookie(GLOBAL_VARIABLE.GID_KEY)
    locale = locale || this.getCookie(GLOBAL_VARIABLE.LOCALE_KEY)
    redirect_uri = encodeURIComponent(redirect_uri || location.href)
    
    const params = new URLSearchParams({
      use_game_token: 'false'
    })
    
    this.appendClearParamIfUseCors(params, 'platform', platform)
    this.appendClearParamIfUseCors(params, 'gid', gid)

    platform && params.append('platform', platform)
    gid && params.append('gid', gid)
    locale && params.append('locale', locale)
    options?.ial && params.append('ial', options.ial)
    options?.krpc && options.krpc?.memberAccessCode && params.append('krpc_member_access_code', options.krpc.memberAccessCode)
    options?.jppc && options.jppc?.gm && params.append('jppc_gm', options.jppc.gm)
    redirect_uri && params.append('redirect_uri', redirect_uri)
    
    return params.toString()
  }
}

export default InfaceClient